import './loaders.css';

const LoadingDots = ({ color = 'primary' }) => {
  const colorToClass = {
    primary: 'after:!bg-primary',
  };
  const className = colorToClass[color] || '';
  return (
    <>
      <div className={className} />
      <div className={className} />
      <div className={className} />
      <div className={className} />
      <div className={className} />
      <div className={className} />
      <div className={className} />
      <div className={className} />
    </>
  );
};

// Full-page loader, with circulating dots
export const PageLoader = ({ dotColor = null }) => (
  <div className="fixed z-[100] flex h-full w-full items-center justify-center">
    <div className="lds-roller">
      <LoadingDots color={dotColor} />
    </div>
  </div>
);

// Section loader with circling oval
export const SectionLoader = ({ dotColor = null, message = '' }) => {
  return (
    <div className="flex flex-col items-center justify-center py-4">
      <div className="animate-spin rounded-full h-14 w-14 border-t-4 border-b-4 border-teal"></div>
      <p className="text-center">{message}</p>
    </div>
  );
};

// Button loader, with animated dots in a line
export const ButtonLoader = ({ color }) => {
  const colorToClass = {
    primary: '!bg-primary',
  };
  const className = colorToClass[color] || '';
  return (
    <div className="lds-ellipsis">
      <div className={className} />
      <div className={className} />
      <div className={className} />
      <div className={className} />
    </div>
  );
};

export const LayerLoader = () => {
  return (
    <>
      <div className="animate-spin rounded-full h-4 w-4 ml-3 border-t-2 border-b-2 border-blue"></div>
    </>
  );
};
